import { useMemo } from "react";

import { useFilter } from "~/providers/FilterProvider";

import { getStatusFilterVisibility } from "./config";

export const useStatusFilterVisibility = () => {
  const { filters } = useFilter();

  return useMemo(
    () =>
      getStatusFilterVisibility({
        active: filters.active,
        resolved: filters.resolved,
      }),
    [filters.active, filters.resolved]
  );
};
